import { render, staticRenderFns } from "./CreateSub.vue?vue&type=template&id=ed463efa&scoped=true&"
import script from "./CreateSub.vue?vue&type=script&lang=ts&"
export * from "./CreateSub.vue?vue&type=script&lang=ts&"
import style0 from "./CreateSub.vue?vue&type=style&index=0&id=ed463efa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed463efa",
  null
  
)

export default component.exports